import OpenAI, { ClientOptions } from 'openai';
import { NIL_UUID } from 'v2/core/entities/uuid';
import { PROXY_OPENAI_URL } from '../constants';

type OpenAIClientOptions = Omit<
  ClientOptions,
  'baseURL' | 'apiKey' | 'dangerouslyAllowBrowser'
>;

let openAIInstance: OpenAI | null = null;

export const getOpenAILLM = (opts?: OpenAIClientOptions) => {
  if (openAIInstance) {
    return openAIInstance;
  }

  openAIInstance = new OpenAI({
    baseURL: PROXY_OPENAI_URL,
    apiKey: NIL_UUID,
    dangerouslyAllowBrowser: true,
    ...opts,
  });

  return openAIInstance;
};
